import * as React from "react"
import { Typography, Tooltip } from "@mui/material"


const FRONT_VERSION = process.env.APP_VERSION || 'dev'
const FRONT_COMMIT = (process.env.GIT_COMMIT || 'dev').slice(0, 7)

export default function VersionBadge() {
    const [backCommit, setBackCommit] = React.useState(null)

    React.useEffect(() => {
        fetch('/api/version')
            .then(res => res.json())
            .then(data => setBackCommit((data.commit || 'unknown').slice(0, 7)))
            .catch(() => setBackCommit('error'))
    }, [])

    const tooltip = [
        `Front: v${FRONT_VERSION} (${FRONT_COMMIT})`,
        `Back: ${backCommit || '...'}`,
    ].join('\n')

    return (
        <Tooltip title={<span style={{ whiteSpace: 'pre-line' }}>{tooltip}</span>} placement="top">
            <Typography
                variant="caption"
                sx={{
                    position: 'fixed',
                    bottom: 8,
                    left: 12,
                    opacity: 0.45,
                    fontSize: '0.65rem',
                    cursor: 'default',
                    zIndex: 1,
                    userSelect: 'none',
                    '&:hover': { opacity: 1 },
                }}
            >
                v{FRONT_VERSION} · {FRONT_COMMIT}
            </Typography>
        </Tooltip>
    )
}
